import React,{useState,useEffect} from "react";
import { useDispatch } from "react-redux";
import {clientAppUserSignUp } from "../../../store/actions/User";

import Loading from "../../Loading/Loading";
import { useSelector } from "react-redux";
import { useHistory } from "react-router-dom/cjs/react-router-dom";
import './loginSignUpT1.css'
import {  Link  } from "react-router-dom";
const SignUpT1 = ()=>{
  
 const dispatch = useDispatch();
 const handleMouseEnter = () =>dispatch({
  type: "CURSOR",
  
  payload:true
});
const handleMouseLeave = () => dispatch({
  type: "CURSOR",
  
  payload:false
});

 useEffect(()=>{
  
        dispatch({
          type: "pageTitle",
          
          payload:"Sign Up | MyApp"
        });
        dispatch({
          type: "pageDescription",
          
          payload:"This is a dynamic description."
        });dispatch({
          type: "pageSEO",
          
          payload:"seo, react, meta"
        });
      },[])
  

   const [loginPopUp , setLoginPopUp] =useState(true);

 const history = useHistory();
 
 const localToken= localStorage.getItem("profile");
 const token = useSelector((state)=>state?.user?.user?.token);

 const AppToken = useSelector((state)=>state?.course?.course?.AppToken);
 const postIdCourse = useSelector((state)=>state?.course?.course?.postId);

 const [loader , setLoader] =useState({status:false});
 const [signup, setSignup] = useState({firstName:"",userEmail:'',userPassword:"", 
 acceptTermsAndConditions:true
 
});

    const loginSignUpPopUp = useSelector((state)=>state?.app?.loginSignUpPopUp);
  



/* Handle Signup Function */
const handleSignUp=(e)=>{
  e.preventDefault();
//console.log(signup)

setLoader({status:true});
  const user = dispatch(clientAppUserSignUp(signup));
 
  /* get response as Promise   */
  
  user.then(response => {
  if(response){
    // set error message
    console.log(response)
   
setInterval(()=>{
 // hide poped message 
 
},3000)
}else {
  console.log(response.user)
}

/* resetting Signup input Fields */

setSignup({firstName:"",userEmail:'',userPassword:"",

acceptTermsAndConditions:true

})

setLoader({status:false});


// history.push('/dashboard/');


  }).catch(error => {
    
    /* resetting Signup input Fields */
    // pop up with something message 
      
       
       setInterval(()=>{
        // hide poped message 
        
       },3000)
    
    
    setSignup({firstName:"",userEmail:'',userPassword:"",   acceptTermsAndConditions:true
    
    })
    setLoader({status:false});
      //  console.error(error);
      });
 
  }

    return <>
    
{(token===localToken&&token&&localToken)?
  <>
<div className="outer-all ">
  
<div></div>
  <div className = {` outer-left `}  id="outer-left">
  
 
      
      </div>
    <div className="outer-right">
        <div className="content-topk">
          <h1> You Are Already logged In</h1>
        </div>
        <div className="outer-logged-in">

</div></div></div>
</>  :<>

{<Loading  Load={loader?.status}/>}
  <form onSubmit={handleSignUp} > {loginSignUpPopUp=="signUp"?<div onClick={() => dispatch({
    type: "LoginSignUpPopUp",
    
    payload:""
  })}  className="cm_theme1_login-signup-backgropj"></div>:""} 
    
 <div  className="cm_theme1_login-signup-card"><div  className="blank"> </div>
  <div  className="cm_theme1_login-signup-card-outerj"><div  className="cm_theme1_login-signup-inner">
    <div  className="cm_theme1_login-signup-left-signup ">
      <h1 style={{"textAlign":"center"}}>SignUp</h1>
      <div  className="cm_theme1_login-input-card-half ">
        <div  className="cm_theme1_login-input-card">
         <input className="cm_theme1_input-textbox" required placeholder="First Name" type="text" name="first_name" value={signup.firstName} onChange={(e)=>setSignup({...signup, firstName : e.target.value})} />
</div><div  className="cm_theme1_login-input-card"> 
 </div></div>
 <div  className="cm_theme1_login-input-card">
 <input className="cm_theme1_input-textbox" required placeholder="Email" type="text" name="user_email" value={signup.userEmail} onChange={(e)=>setSignup({...signup, userEmail : e.target.value})} />
   </div><div  className="cm_theme1_login-input-card">
    
     <input className="cm_theme1_input-textbox" required placeholder="Password" type="text" name="user_pass" value={signup.userPassword} onChange={(e)=>setSignup({...signup, userPassword : e.target.value})} />
    </div>
	  
   
   
    
   
     <div  className="cm_theme1_login-input-card"><div  ></div>
     <div className="tandC_style">
  <label className="cm_theme1_checkbox-outer">I Accept Terms And Conditions:
  <input
          type="checkbox"
          name="acceptTermsAndConditions"
         
          checked={signup.acceptTermsAndConditions}
          onChange={(e)=>setSignup({...signup, acceptTermsAndConditions:!signup.acceptTermsAndConditions})}
        />
  <span className="cm_theme1_square"></span>
</label>    </div></div>
   
	
	<div  className="cm_theme1_login-input-card">
  <div  style={{padding:'15px',fontSize:'14px',fontWeight:'bold',textAlign:'center'}}> 
        Join classmock.com today! It's easy! Just sign up with your email, and start exploring.  </div>
  
  <button  className="cm_theme1_login-signup-button" type="submit" id="signupBtn">Create Account</button>
      
  </div>
  
 </div>
    
    <div  className="cm_theme1_blankRight ">
      <div>


        
      </div>
      <div>   <div  className="flex-space-between">  <div  style={{width:"240px",padding:"15px",borderRadius:"15px",marginTop:"10px"}}><img style={{width:"100%"}}
       alt="logo" src="https://i.postimg.cc/7Zwy3WW9/Testprism_Logo.png"/> </div>

      </div>
      
<h3  style={{textAlign:"center"}}>App Tag Line</h3>
<div className="logo-box-shadow">
<div className=""  style={{padding:'10px',color:"#222",fontSize:'22px',textAlign:"center"}}> Already Have An Account?   </div>
<div  className=""  style={{padding:'10px',color:"#666",fontSize:'15px',textAlign:"center"}}>
  Login And Access Your Courses   . </div>

       <div className="flex-space-between"> 
       <div className="">
      
       {loginPopUp?<div
                onClick={() => dispatch({
                  type: "LoginSignUpPopUp",
                  
                  payload:"login"
                })} className="cm_theme1_course-btn-green-two" style={{fontSize:"16px"}}>
                 Login Here.
                </div>:<Link to="./login">
            <div className="ikcraft_course-btn-green-two" style={{fontSize:"16px"}}>
           Login Here.
          </div> </Link>}</div></div>
          
          
          <div style={{padding:'5px',fontSize:'18px',color:'#958FDA',textAlign:'center'}} > OR </div>
          {loginSignUpPopUp=="signUp"?<div  className="cm_theme1_login-input-card">
             
             <button onClick={() => dispatch({
                 type: "LoginSignUpPopUp",
                 
                 payload:"loginWithOTP"
               })}  onMouseEnter={handleMouseEnter}
                onMouseLeave={handleMouseLeave}   className="cm_theme1_login-signup-button-two" type="submit" id="signupBtn">Login With OTP </button>
                 
             </div>:<Link to="./loginWithOTP">
            <div  className="cm_theme1_login-input-card">
             
            <button   onMouseEnter={handleMouseEnter}
               onMouseLeave={handleMouseLeave}   className="cm_theme1_login-signup-button-two" type="submit" id="signupBtn">Login With OTP </button>
                
            </div></Link>}</div></div>
    </div>
  </div></div><div></div></div>
   </form>
</>}
    </>

}
export default SignUpT1;